import { render, staticRenderFns } from "./goodsOfferDialog.vue?vue&type=template&id=3718b959&scoped=true&"
import script from "./goodsOfferDialog.vue?vue&type=script&lang=js&"
export * from "./goodsOfferDialog.vue?vue&type=script&lang=js&"
import style0 from "./goodsOfferDialog.vue?vue&type=style&index=0&id=3718b959&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3718b959",
  null
  
)

export default component.exports